import { Accordion, useBreakpoint } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import { useToggleCovers } from "../../hooks/useToggleCovers";
import type { WithMetadata } from "../../pages";
import { CoverToggle } from "./CoverToggle/CoverToggle";
import { PaymentToggle } from "../shared/PaymentToggle";
import type { CoverTogglesData, PaymentPeriod } from "../QuoteCards/types";
export interface CoverTogglesContainerProps {
  coverTogglesData: CoverTogglesData[];
  variant?: "payment-aside" | undefined;
  paymentPeriod?: PaymentPeriod;
  showToggle: boolean;
  shouldRecordPreference: boolean;
}

export const CoverTogglesContainer = (
  props: WithMetadata<CoverTogglesContainerProps>,
) => {
  const {
    coverTogglesData,
    componentName,
    variant,
    paymentPeriod,
    showToggle = false,
    shouldRecordPreference = false,
  } = props;
  const { up } = useBreakpoint();
  const isDesktop = up("lg");
  const isPaymentAside = variant === "payment-aside";
  const outerClasses = classNames("mobius-cover-toggles-container__outer", {
    "--is-payment-aside": isPaymentAside,
  });
  const classes = classNames("mobius-cover-toggles-container", {
    "--is-collapsible": isPaymentAside,
    "--is-desktop": isDesktop,
  });
  // Handle toggle covers request
  const { toggleCovers, isPending, isError } = useToggleCovers();

  const showCoverToggles = coverTogglesData?.length > 0;

  const CoverToggles = (coverTogglesData || []).map(toggle => (
    <CoverToggle
      key={toggle.fieldName}
      {...toggle}
      onChange={cover => {
        toggleCovers({
          name: toggle.fieldName,
          value: cover.toValue,
        });
      }}
      isLoading={isPending}
      isError={isError}
    />
  ));

  const CoverTogglesContainerContent = () => (
    <div className={classes} data-testid="cover-toggles-container">
      {CoverToggles}
    </div>
  );

  return (
    <div
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
      className={outerClasses}
      data-testid="cover-toggles-outer-container"
    >
      {showCoverToggles &&
        (isPaymentAside ? (
          <Accordion
            data-testid="cover-toggles-accordion"
            startOpen={isDesktop}
            showText="Change limits"
            hideText="Change limits"
          >
            <CoverTogglesContainerContent />
          </Accordion>
        ) : (
          <CoverTogglesContainerContent />
        ))}
      {showToggle && (
        <PaymentToggle
          paymentTogglePeriod={paymentPeriod}
          shouldRecordPreference={shouldRecordPreference}
        />
      )}
    </div>
  );
};
